import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container,Col,Row, Button } from 'reactstrap';
import { Preloader } from '../Plugins';
import 'rc-datetime-picker/dist/picker.css';
import {
	REPORT_ADMIN,
	REPORT_OUT_OF_STOCK,
	REPORT_ZUPPER_SELLS,
	REPORT_BANCAMIGA,
	REPORT_BALANCE_MODIFIERS,
	REPORT_CITY_MOVEMENTS,
	REPORT_CITY_SUMMARY,
	REPORT_BRANCH_DETAILS,
	REPORT_BRANCH_GROUP_SALE_DETAILS,
	REPORT_BRANCH_PENDING_FEES,
	REPORT_BRANCH_PAID_INVOICES,
	REPORT_BRANCH_PAID_INVOICES_ALT,
	REPORT_PAID_ORDERS_TO_BRANCH,
	REPORT_PENDING_FEES_TO_RIDERS,
	REPORT_RIDERS_PAID_INVOICES,
	REPORT_RIDERS_ONLINE,
	REPORT_RIDERS_MOVEMENTS,
	REPORT_RIDERS_STATUS,
	REPORT_ACCESS,
	REPORT_USERS,
	REPORT_USERS_EMAIL,
	REPORT_CLIENTS_WITH_BALANCE,
	REPORT_CLIENTS_MOVEMENTS,
	REPORT_CLIENT_PAID_INVOICES,
	REPORT_USER_LOGINS,
	REPORT_COMPANY_SALES,
	REPORT_COMPANY_PAYMENT_DETAILS,
	REPORT_RECENT_USERS,
	REPORT_GENERAL_ORDERS,
	REPORT_COMPANY_FINANCE_ORDERS,
	REPORT_COMPANY_ORDERS_REVENUE,
	REPORT_ORDER_RATINGS,
	REPORT_BRANCH_ORDERS,
	REPORT_RIDERS_EARNINGS,
	REPORT_RIDER_EARNINGS,
	REPORT_GENERAL_OPERATIONS_OF_RIDERS,
	REPORT_GENERAL_OPERATIONS_OF_RIDER,
	REPORT_PRODUCTS_PURCHASED_BY_USERS,
	REPORT_PRODUCTS_SOLD_BY_BRANCH,
	REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH,
	REPORT_TOTAL_PRODUCTS_SOLD,
	REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER,
	REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH,
	REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH,
	REPORT_ORDERS_BY_USER,
	REPORT_CLIENT_PENDING_INVOICES,
	REPORT_BRANCH_LIST,
	REPORT_BRANCH_REPORTS,
	REPORT_COUPONS,
	REPORT_COUPON_INVESTMENTS,
	REPORT_AVAILABLE_COUPONS,
	REPORT_USED_COUPONS,
	REPORT_BRANCH_PROMOTION,
	REPORT_BRANCH_MOVEMENTS,
	REPORT_PROVIDER_FEES,
	REPORTS_LIST
} from '../../constants/general';
import { withApiService } from '../../api'
import ReportItemRow from './ReportItemRow'
import { fetchCompanyCities } from '../../store/actions/companyActions';
import ModalBase from '../Plugins/MainModals/ModalBase';
import ModalReportsHistories from './ModalReportsHistories';
class Reports extends Component {
	constructor(props){
		super(props);
		this.state = {
			adminType: this.props.session.admin_type,
			reportsList: REPORTS_LIST.filter(item => {
				return item.reports.some(report => (report.permissions.hierarchy <= this.props.accountType));
			}),
			selectType: "general"
		}
	}

	componentDidMount() {
		const { adminType, reportsList } = this.state;
		this.props.fetchCompanyCities();
		if(adminType){
			const filteredRoles = adminType.roles.filter(rol => rol.role.startsWith("access_report") && rol.role !== "access_reports");
			const splitedReports = filteredRoles.map(rol => rol.role.split('_')[1]);
			const newReportsList = reportsList
				.map(item => ({
					...item,
					reports: item.reports.filter(report => splitedReports.some(rol => report.value === rol))
				}))
				.filter(item => item.reports.length > 0);

			this.setState({
				reportsList: newReportsList
			});
		}
	}

	handleReportsQuery(query, value){
		switch(value){
			case REPORT_ADMIN:
				return this.props.api.reports.admins();
			case REPORT_OUT_OF_STOCK:
				return this.props.api.reports.downloadSoldoutGoods(query.branch_id);
			case REPORT_ZUPPER_SELLS:
				return this.props.api.reports.branchSales();
			case REPORT_BANCAMIGA:
				return this.props.api.reports.bancamigaReport();
			case REPORT_BALANCE_MODIFIERS:
				return this.props.api.reports.balanceModifiers();
			case REPORT_CITY_MOVEMENTS:
				return this.props.api.reports.cityMovements();
			case REPORT_CITY_SUMMARY:
				return this.props.api.reports.citySummary();
			case REPORT_BRANCH_DETAILS:
				return this.props.api.reports.branchAgreements();
			case REPORT_BRANCH_GROUP_SALE_DETAILS:
				return this.props.api.reports.branchGroupSaleDetails();
			case REPORT_BRANCH_PENDING_FEES:
				return this.props.api.reports.branchInvoices();
			case REPORT_BRANCH_PAID_INVOICES:
			case REPORT_BRANCH_PAID_INVOICES_ALT:
				return this.props.api.reports.branchPaidInvoices();
			case REPORT_PAID_ORDERS_TO_BRANCH:
				return this.props.api.reports.branchInvoicesEarnings();
			case REPORT_PENDING_FEES_TO_RIDERS:
				return this.props.api.reports.providersInvoices();
			case REPORT_RIDERS_PAID_INVOICES:
				return this.props.api.reports.providerPaidInvoices();
			case REPORT_RIDERS_ONLINE:
				return this.props.api.reports.providerOnline();
			case REPORT_RIDERS_MOVEMENTS:
				return this.props.api.reports.providerBalance();
			case REPORT_RIDERS_STATUS:
				return this.props.api.reports.providerStatus();
			case REPORT_ACCESS:
				return this.props.api.reports.companyAccesses();
			case REPORT_USERS:
				return this.props.api.reports.clients();
			case REPORT_USERS_EMAIL:
				return this.props.api.reports.clientsSlimAll();
			case REPORT_CLIENTS_WITH_BALANCE:
				return this.props.api.reports.userWithBalance();
			case REPORT_CLIENTS_MOVEMENTS:
				return this.props.api.reports.clientMovements();
			case REPORT_CLIENT_PAID_INVOICES:
				return this.props.api.reports.clientPaidInvoices();
			case REPORT_USER_LOGINS:
				return this.props.api.reports.clientsSlimEmail();
			case REPORT_COMPANY_SALES:
				return this.props.api.reports.companySales();
			case REPORT_COMPANY_PAYMENT_DETAILS:
				return this.props.api.reports.paymentDetails();
			case REPORT_RECENT_USERS:
				return this.props.api.reports.clientsSlim();
			case REPORT_GENERAL_ORDERS:
				return this.props.api.reports.companyOrders();
			case REPORT_COMPANY_FINANCE_ORDERS:
				return this.props.api.reports.companyFinanceOrders();
			case REPORT_COMPANY_ORDERS_REVENUE:
				return this.props.api.reports.companyOrdersRevenue();
			case REPORT_ORDER_RATINGS:
				return this.props.api.reports.companyOrdersRatings();
			case REPORT_BRANCH_ORDERS:
				return this.props.api.reports.branchOrders(query.branch_id);
			case REPORT_RIDERS_EARNINGS:
				return this.props.api.reports.providerEarnings();
			case REPORT_RIDER_EARNINGS:
				return this.props.api.reports.providerEarnings(query.provider_id);
			case REPORT_GENERAL_OPERATIONS_OF_RIDERS:
				return this.props.api.reports.providerDetailedEarnings();
			case REPORT_GENERAL_OPERATIONS_OF_RIDER:
				return this.props.api.reports.providerDetailedEarnings(query.provider_id);
			case REPORT_PRODUCTS_PURCHASED_BY_USERS:
			case REPORT_PRODUCTS_SOLD_BY_BRANCH:
			case REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH:
				return this.props.api.reports.orderedGoods();
			case REPORT_TOTAL_PRODUCTS_SOLD:
			case REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER:
			case REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH:
				return this.props.api.reports.goods();
			case REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH:
			case REPORT_ORDERS_BY_USER:
				return this.props.api.reports.clientOrders();
			case REPORT_CLIENT_PENDING_INVOICES:
				return this.props.api.reports.clientPendingInvoices();
			case REPORT_BRANCH_LIST:
				return this.props.api.reports.branches();
			case REPORT_BRANCH_REPORTS:
				return this.props.api.reports.branchGoods(query.branch_id);
			case REPORT_COUPONS:
				return this.props.api.reports.coupons();
			case REPORT_COUPON_INVESTMENTS:
				return this.props.api.reports.couponInvestments();
			case REPORT_AVAILABLE_COUPONS:
				return this.props.api.reports.availableCoupons();
			case REPORT_USED_COUPONS:
				return this.props.api.reports.usedCoupons();
			case REPORT_BRANCH_PROMOTION:
				return this.props.api.reports.promos();
			case REPORT_BRANCH_MOVEMENTS:
				return this.props.api.reports.businessMovements(query.branch_id);
			case REPORT_PROVIDER_FEES:
				return this.props.api.reports.providerFees(query.branch_id);
			default:
				break;
		}
	}

	toggleModal(modal) {
		this.refs[modal].toggleModal()
	}

	handleSelectChange(value){
		this.setState({
			selectType: value
		})
	}

	render() {
		const { reportsList, selectType } = this.state;
		const { json_lang, session } = this.props;

		const NEW_REPORTS_LIST = reportsList.filter(item => {
			if(this.props.branch.id){
				return item;
			} else{
				return item.reports.some(report => !report.permissions.withAllBranches);
			}
		}).filter(item => {
			if(selectType === "general"){
				return true;
			} else{
				return item.type === selectType;
			}
		});

		const reportsTypes = [
			{
				name: json_lang.settings.information_title,
				value: "general"
			}
		]

		reportsList.forEach(item => {
			if(item.type){
				reportsTypes.push({
					name: json_lang.common[item.type],
					value: item.type
				})
			}
		})

		return <Container className="mt-4" fluid>
			<Col>
				<div className="d-flex flex-row justify-content-between mb-2">
					<div className="d-flex">
						<h2 className="font-weight-bold mr-2">{json_lang.reports.reports}</h2>
						{
							reportsTypes.length > 2 && (
								<select
									className="form-control"
									value={selectType}
									onChange={(e) => this.handleSelectChange(e.target.value)}
								>
									{
										reportsTypes.map((reportType, index) => (
											<option key={index} value={reportType.value}>
												{reportType.name}
											</option>
										))
									}
								</select>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
							)
						}
					</div>
					<Button
						color="primary"
						onClick={() => this.toggleModal('history')}
					>
						Historial
					</Button>
				</div>
				<Row className="justify-content-center">
					{
						NEW_REPORTS_LIST.map((item, index) => (
							<div key={index} className="mt-2 w-100">
								<h2 className="font-weight-bold">{json_lang.common[item.type]}</h2>
								<table className="table-outline d-sm-table table table-hover" style={{background:"white"}}>
									<thead className="thead-light">
										<tr>
											<th>{json_lang.common.name}</th>
											<th></th>
											<th></th>
											<th className="text-right">{json_lang.common.actions}</th>
										</tr>
									</thead>
									<tbody>
										{item.reports.map(report => (
											<ReportItemRow
												key={report.value}
												title={
													(report.permissions.dependsOnBranch || report.permissions.branchRequired)
													? (
														this.props.branch.name
														? report.name.replace("comercio", this.props.branch.name)
														: report.name
													)
													: report.name
												}
												cityId={session.city_id}
												withFile={report.permissions.withFile}
												withDates={report.permissions.withDates}
												forceCity={report.permissions.forceCity}
												autoBranch={report.permissions.autoBranch}
												withClients={report.permissions.withClients}
												withBranches={
													report.permissions.dependsOnBranch
													? !this.props.branch.id
													: report.permissions.withBranches
												}
												maxDateRange={report.permissions.maxDateRange}
												withProviders={report.permissions.withProviders}
												activateModal={report.permissions.activateModal}
												withCityFilter={report.permissions.withCityFilter}
												withAllBranches={report.permissions.withAllBranches}
												withTimezone={report.permissions.withTimezone}
												withBranchGroups={report.permissions.withBranchGroups}
												branchAsParameter={report.permissions.branchAsParameter}
												appendingQueryString={report.permissions.appendingQueryString}
												url={({ query }) => this.handleReportsQuery(query, report.value)}
											/>
										))}
									</tbody>
								</table>
							</div>
						))
					}
				</Row>
			</Col>
			<ModalBase ref={`history`}
				title={
					'Histórico de reportes'
				}
				style = {{
					maxWidth: "1000px"
				}}
				html={
					<ModalReportsHistories 
						reportsList={reportsList} 
						handleReportsQuery={ (query, value) => this.handleReportsQuery(query, value)}

					/>
				}
			/>
			<Preloader />
		</Container>
	}
}

const mapStateToProps = (state) => ({
	session: state.session,
	accountType: state.session.account.type,
	json_lang: state.json_lang,
	company: state.company,
	branches: state.branches,
	branch: state.branch
})

const mapDispatchToProps = (dispatch) => ({
	fetchCompanyCities:() => dispatch(fetchCompanyCities())
})

export default connect(mapStateToProps,mapDispatchToProps)(withApiService(Reports));



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js